import { SelectOptionValue, Icon } from '@tencent/udesign/dist';
import { IConfigField } from '../../../model';
import { getLabel } from '../../../libs';
import {
  forwardRef,
  useImperativeHandle,
  useState,
  useRef,
  ChangeEvent,
  useEffect,
  KeyboardEvent,
} from 'react';
interface IProps<T> {
  type: 'button' | 'default';
  placeholder: string;
  isMultiple: boolean;
  selectAllLabel: string;
  fieldConfig: IConfigField<T>;
  onClickClear: () => void;
  openSelect: boolean;
  setOpenSelect: (state: boolean) => void;
  newValue?: ReadonlyArray<SelectOptionValue> | SelectOptionValue;
  isSelectAll?: boolean;
  selectValue?: (val: string) => void;
}
const RenderSelectedLabel = <T,>(props: IProps<T>, ref?: any) => {
  const {
    type,
    placeholder,
    isMultiple,
    selectAllLabel,
    fieldConfig,
    onClickClear,
    newValue,
    isSelectAll,
    setOpenSelect,
    openSelect,
    selectValue,
  } = props;
  const inputRef = useRef<HTMLInputElement>(null);
  const [value, setValue] = useState<string>('');

  // 此处注意useImperativeHandle方法的的第一个参数是目标元素的ref引用
  useImperativeHandle(ref, () => ({
    focusInput: () => {
      if (inputRef.current) {
        window.setTimeout(() => {
          focusInput();
        }, 100);
      }
    },
    emptyInput: () => {
      if (value) {
        setValue('');
        if (selectValue) {
          selectValue('');
        }
      }
    },
    getKeyword: () => {
      return value;
    },
  }));
  const focusInput = () => {
    if (inputRef.current) {
      inputRef.current.focus();
      setOpenSelect(true);
    }
  };
  // 获取input回调
  const onChange = (event: ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.value);
    if (selectValue) {
      selectValue(event.target.value);
    }
  };

  // 当input框失焦时关闭 父组件 的下拉框
  const onBlur = () => {
    setValue('');
    if (selectValue) {
      selectValue('');
    }
    setOpenSelect(false);
  };

  // 监听input框输入 select组件中输入空格相当于选中数据 所以当输入空格时取消冒泡
  const onKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.code === 'Space') {
      event.stopPropagation();
    }
  };
  useEffect(() => {
    // 当value 不是空字符串时 并且 openSelect 为true 时
    // 代表 这个时候 用户切换了屏幕 但input框并没有失焦 所以展示下拉框
    if (value.length > 0 && !openSelect) {
      setOpenSelect(true);
    }
  }, [value]);

  const label = getLabel(
    isMultiple,
    selectAllLabel,
    fieldConfig,
    newValue,
    isSelectAll
  );
  // button 模式下
  if (type === 'button') {
    return (
      <span className={`${label ? 'btn-text' : 'tag-placeholder'}`}>
        {label || placeholder}
      </span>
    );
  }

  return (
    <div className="u-select-tags allowed">
      <div className="tag-values">
        <div
          className={`${
            label || value.length > 0 ? 'tag-single' : 'tag-placeholder'
          } ${openSelect ? 'focused' : ''} ${
            value.length === 0 ? 'word-null' : 'word-not-null'
          }`}
        >
          {label || placeholder}
        </div>
        <input
          ref={inputRef}
          className="tag-input"
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          onKeyDown={onKeyDown}
        />
      </div>
      <div className="tag-indicators">
        {Array.isArray(newValue) && newValue.length > 0 && !value ? (
          <span className="indicator-clear" onClick={onClickClear}>
            <Icon icon="mdi-close-circle" />
          </span>
        ) : null}
        <span className="indicator-dropdown">
          <Icon icon="mdi-chevron-down" />
        </span>
      </div>
    </div>
  );
};
// 由于 RenderSelectedLabel 组件是函数式组件 没有实例 所以使用 forwardRef 做转发
export const ForwardSelectedLabel = forwardRef(RenderSelectedLabel);
